// extracted by mini-css-extract-plugin
export var fileUpload = "_f6-1";
export var modalButton = "_f6-0";